import React, { useEffect, useState } from "react";
import { MisDocumentosContextProvider } from "context/v3/MisDocumentosContextProvider";
import { Body } from "./Body";
import { ModalFirmar } from "pages/v3/mis-pendientes/componentes/ModalFirmar";
import { ModalExito } from "pages/v3/mis-pendientes/componentes/ModalExito";
import { Plataforma } from "enum/Plataforma";
import { ModalConsultar } from "./ModalConsultar";

const VisorPdfPageV3 = () => {
	const [plataforma, setPlataforma] = useState(
		localStorage.getItem("plataforma")
	);

	useEffect(() => {
		if (
			plataforma === undefined ||
			plataforma === "" ||
			plataforma === null
		) {
			setPlataforma(Plataforma.MOVIL_WEB);
		}
	}, []);

	return (
		<MisDocumentosContextProvider>
			<Body />
			<ModalFirmar plataforma={plataforma} />
			<ModalConsultar />
			<ModalExito />
		</MisDocumentosContextProvider>
	);
};

export default VisorPdfPageV3;
